import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ADS_ID = 'AW-17657359987';

export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    try {
      const pagePath = location.pathname + location.search + location.hash;
      const gtag = (window as any).gtag as undefined | ((...args: any[]) => void);
      if (typeof gtag === 'function') {
        // SPA page view for Google Ads
        gtag('config', ADS_ID, { page_path: pagePath });
        // Optionally also send explicit page_view event
        gtag('event', 'page_view', { send_to: ADS_ID, page_path: pagePath });
      }
    } catch {
      // no-op
    }
  }, [location]);

  return null;
}

